import { DeviceTypes } from '../../../constants/DeviceModels';
import { timerKey } from '../../../utils/timer-manager/timer-manager';

/**
 * Boot turn on
 *
 * @param rootStore
 * @param onFinish
 */
export const bootSwitch = (rootStore, onFinish = () => {}) => {
  const { batchStore, devicesStore } = rootStore;
  const boot = devicesStore.devices.find(v => v.deviceTypeName === DeviceTypes.Boot);

  if (boot?.upPNo) {
    if (boot.autoTurnOn === false) {
      onFinish();
      return;
    }

    batchStore.timers.set(timerKey.device(boot.id), () => {
      batchStore.setOutput(boot.upPNo, (boot.duration || 0) * 1000);

      batchStore.timers.set(timerKey.device(boot.id), () => {
        onFinish();
      }, (boot.duration || 0) * 1000, `Boot device #${boot.id} - duration`);

    }, (boot.delay || 0) * 1000, `Boot device #${boot.id} - initial delay`);
  } else {
    onFinish();
  }
};
